export const CookieConsent = require("./CookieConsent").default;